import { computed } from "vue";
import { useBreakpoints } from "./useBreakpoints";
import { useModifiers } from "./useModifiers";

export function useVariant(props) {
  const { isSmScreen } = useBreakpoints();
  const variant = computed(() => (isSmScreen.value && props.smVariant ? props.smVariant : props.variant));
  const modifiersProps = computed(() => ({ variant: variant.value }));
  const { modifiers } = useModifiers(modifiersProps, "variant");
  const variantModifiers = computed(() => modifiers.value);

  return {
    variant,
    variantModifiers,
  };
}
